import { DepositPaymentStatusEnum } from '@shared/api/rest/payment';
import { TransferRequestStatusEnum } from '@shared/api/rest/transferRequests';
import { splitCamelCase } from './splitCamelCase';
import { TransactionStatusEnum } from '@shared/api/rest/transactions';

export class ColorUtils {
  static getRandomColor = () => {
    const letters = '0123456789ABCDEF';
    let color = '#';

    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }

    return color;
  };

  static getDepositPaymentStatusStyles = (status?: DepositPaymentStatusEnum) => {
    switch (status) {
      case DepositPaymentStatusEnum.Completed:
        return { bg: 'bg-dark-emerald', text: 'text-emerald', label: DepositPaymentStatusEnum.Completed };
      case DepositPaymentStatusEnum.Failed:
        return { bg: 'bg-light-carmine-pink', text: 'text-purple-pink', label: DepositPaymentStatusEnum.Failed };
      case DepositPaymentStatusEnum.Rejected:
        return { bg: 'bg-light-carmine-pink', text: 'text-purple-pink', label: DepositPaymentStatusEnum.Rejected };
      case DepositPaymentStatusEnum.Cancelled:
        return { bg: 'bg-light-carmine-pink', text: 'text-purple-pink', label: DepositPaymentStatusEnum.Cancelled };
      case DepositPaymentStatusEnum.Draft:
        return { bg: 'bg-dark-red-sand', text: 'text-red-sand', label: DepositPaymentStatusEnum.Draft };
      case DepositPaymentStatusEnum.Returned:
        return { bg: 'bg-light-carmine-pink', text: 'text-purple-pink', label: DepositPaymentStatusEnum.Returned };
      case DepositPaymentStatusEnum.Processing:
        return { bg: 'bg-dark-red-sand', text: 'text-red-sand', label: DepositPaymentStatusEnum.Processing };
      default:
        return { bg: 'bg-light-gray', text: 'text-black', label: status };
    }
  };

  static getTransferRequestStatusStyles = (status?: TransferRequestStatusEnum) => {
    switch (status) {
      case TransferRequestStatusEnum.Submitted:
        return { bg: 'bg-emerald bg-opacity-10', text: 'text-emerald', label: TransferRequestStatusEnum.Submitted };
      case TransferRequestStatusEnum.Cancelled:
        return { bg: 'bg-purple-pink bg-opacity-10', text: 'text-purple-pink', label: TransferRequestStatusEnum.Cancelled };
      case TransferRequestStatusEnum.WaitingForApproval:
        return { bg: 'bg-red-sand bg-opacity-10', text: 'text-red-sand', label: splitCamelCase(TransferRequestStatusEnum.WaitingForApproval) };
      case TransferRequestStatusEnum.Draft:
        return { bg: 'bg-red-sand bg-opacity-10', text: 'text-red-sand', label: TransferRequestStatusEnum.Draft };
      case TransferRequestStatusEnum.Scheduled:
        return { bg: 'bg-red-sand bg-opacity-10', text: 'text-red-sand', label: TransferRequestStatusEnum.Scheduled };
      default:
        return { bg: 'bg-red-sand bg-opacity-10', text: 'text-red-sand', label: status };
    }
  };

  static getTransactionStatusStyles = (status?: TransactionStatusEnum) => {
    switch (status) {
      case TransactionStatusEnum.APPROVED:
        return { bg: 'bg-very-dark-emerald', text: 'text-emerald', label: TransactionStatusEnum.APPROVED };
      case TransactionStatusEnum.PENDING:
        return { bg: 'bg-very-dark-red-sand', text: 'text-red-sand', label: TransactionStatusEnum.PENDING };
      case TransactionStatusEnum.DECLINED:
        return { bg: 'bg-very-dark-purple-pink', text: 'text-purple-pink', label: TransactionStatusEnum.DECLINED };
      default:
        return { bg: 'bg-light-gray bg-opacity-10 ', text: 'text-black', label: status };
    }
  };
}
